import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AiPortraitTokenService {

  url: string = environment.serviceurl
  aiPortraitUrl: string = this.url + 'api/ai-portrait'
  aiTokenUrl: string = this.url + 'api/tokens'

  constructor(private http: HttpClient) { }

  generateToken(playerDetails: any) {
    return this.http.post(this.aiPortraitUrl + '/generate-character-image/' + playerDetails.user_id + '/', playerDetails);
  }

  generateDescription(playerDetails: any) {
    return this.http.post(this.url + 'api/ai-description/generate-character-description/' + playerDetails.user_id + '/', playerDetails);
  }

  generateBackstory(playerDetails: any) {
    return this.http.post(this.url + 'api/ai-backstory/generate-character-backstory/' + playerDetails.user_id + '/', playerDetails);
  }

  generateContentPortrait(userId: any, payload: any) {
    return this.http.post(this.url + 'api/ui/content/portrait/generate/' + userId + '/', payload);
  }

  generateFullCharacter(playerDetails: any) {
    return this.http.post(this.url + 'api/ai-character/generate-full-character/' + playerDetails.user_id + '/', playerDetails);
  }

  getTokenBalance(userId: number | string) {
    return this.http.get(this.aiTokenUrl + '/balances/' + userId + '/');
  }

  getTokenTransaction(userId: number | string) {
    return this.http.get(this.aiTokenUrl + '/transactions/' + userId + '/');
  }
}
